/**
 * Punto de extensión de la vista de un registro de una entidad con
 * .projectSlots: un bloque que se dibuja ARRIBA DE TODO, antes del primer grupo
 * (el equivalente de formExtras.tsx en la vista). El PROYECTO llena este
 * archivo; el generador lo emite SIEMPRE con este mismo contenido estable.
 *
 * Solo en las entidades marcadas con .projectSlots en el DSL, y también en la
 * vista de sus proyecciones.
 *
 * La clave es el nombre de la entidad. Props:
 *  - entity:   el nombre de la entidad.
 *  - recordId: el id del registro, cuando la vista lo recibe (las entidades con
 *              validación de datos por mail y los snapshots); si no, undefined.
 *
 * NO EDITAR este stub en el generador: cualquier cambio acá conflictúa con
 * todos los proyectos que lo hayan llenado.
 */
import type { ComponentType } from 'react';
import React from "react";
import { AuthorStatusPanel } from "../../entities/authorComposer/components/common/AuthorStatusPanel";

export interface ViewExtrasProps {
  entity: string;
  recordId?: string;
}

const VistaDelAutor: React.FC<ViewExtrasProps> = ({ recordId }) =>
  recordId ? <AuthorStatusPanel recordId={recordId} /> : null;

// Lleno por Jupiter: "Datos validados con DNI" y advertencias arriba de la vista del autor.
export const viewExtras: Partial<Record<string, ComponentType<ViewExtrasProps>>> = {
  AuthorComposer: VistaDelAutor,
};
